import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import React from 'react';
var LayoutCentered = function (_a) {
    var children = _a.children;
    return (React.createElement(Box, { height: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" },
        React.createElement(Grid, { item: true, md: 5, xs: 10, style: { flexBasis: '60%' } },
            React.createElement(Grid, { container: true, justify: "center" }, children))));
};
export default LayoutCentered;
